import { toFullName } from '@repo/toolkit/to-full-name'
import MultiSelectInput from '@repo/ui/multiselect-input'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getCountries } from '../../../api/countries/get-countries'
import { getContactInParis } from '../../../api/ols/gte-contact-in-paris'
import { OLTypeEnum, olTypeEnumMapping } from '../../../lib/types/enums/ol/ol-type.enum'
import { OlFilters } from '../../../lib/types/models/ol/ol'

interface Props {
  filter?: OlFilters
  onFilterChange: (filter: OlFilters) => void
}

export function OlsFilter({ filter, onFilterChange }: Props) {
  function setFilter<K extends keyof OlFilters>(key: K, value: OlFilters[K]) {
    onFilterChange({ ...filter, [key]: value })
  }

  const { data: users } = useQuery({
    queryKey: ['users'],
    queryFn: getContactInParis
  })
  const { data: countries } = useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries()
  })

  return (
    <div className={'flex flex-col gap-3'}>
      <div />
      <div className="flex flex-col gap-2.5">
        <Typography variant="tag">Statut de l'OL</Typography>
        <div className="flex flex-row gap-5">
          <RadioInput
            checked={filter?.isActive === undefined}
            label={'Les deux'}
            onCheck={() => onFilterChange({ ...filter, isActive: undefined })}
          />
          <RadioInput
            checked={filter?.isActive === true}
            label={'Actif'}
            onCheck={() => onFilterChange({ ...filter, isActive: true })}
          />
          <RadioInput
            checked={filter?.isActive === false}
            label={'Inactif'}
            onCheck={() => onFilterChange({ ...filter, isActive: false })}
          />
        </div>
      </div>

      <MultiSelectInput
        label={'Type de prestataire'}
        variant={'primary'}
        options={Object.values(OLTypeEnum).map((type) => ({
          label: olTypeEnumMapping[type].label,
          value: type
        }))}
        selectedOptions={filter?.types?.map((type) => ({
          label: olTypeEnumMapping[type].label,
          value: type
        }))}
        onChange={(types) => setFilter('types', types)}
      />

      <MultiSelectInput
        label={'Contact à Paris'}
        variant={'primary'}
        options={
          users?.data.map((user) => ({
            label: toFullName(user.firstName, user.lastName),
            value: user.id
          })) ?? []
        }
        selectedOptions={filter?.contactInParisIds?.map((option) => ({
          label: toFullName(
            users?.data.find((user) => user.id === option)?.firstName ?? '',
            users?.data.find((user) => user.id === option)?.lastName ?? ''
          ),
          value: option
        }))}
        onChange={(contactInParisIds) => setFilter('contactInParisIds', contactInParisIds)}
      />

      <MultiSelectInput
        searchable
        label={'Lieu de séjour'}
        variant={'primary'}
        options={countries?.data?.map((country) => ({
          label: country.name,
          value: country.name
        }))}
        selectedOptions={filter?.countries?.map((country) => ({
          label: countries?.data?.find((c) => c.name === country)?.name ?? '',
          value: country
        }))}
        onChange={(countries) => setFilter('countries', countries)}
      />
    </div>
  )
}
